// import PromiseWorker from "promise-worker";
import { IMessageWorker, EWorker, IDTTSerial } from "./defs";
import { BehaviorSubject, Subject } from "rxjs";
import { QueueDataLeanbot } from "../../public/common/js/api/QueueDataLeanbot";
import { LeanbotSleep } from "../../public/common/js/api/util";
import { PWBHost } from "promise-worker-bi";
import { BluetoothHostShareWorker } from "./share-worker-host";
// import $, { readyException } from 'jquery';

class BluetoothSerial implements IDTTSerial {
  // promiseWorker: PromiseWorker;

  messages: QueueDataLeanbot;

  data: Subject<IMessageWorker>;

  // shareBluetooth: PWBHost;
  bluetooth: PWBHost;
  options: SerialOptions;
  shareBluetooth: BluetoothHostShareWorker;
  connectedAtlestOnce: boolean;
  activated: boolean;
  botState: BehaviorSubject<boolean>;
  portIdx: number | false;
  onConnect: Subject<any>;
  lastPort: SerialPort;
  // data: Subject<string>;

  constructor() {
    var blWorker = new Worker(
      new URL('./bluetooth-thread', import.meta.url),
      { type: 'module' }
    );
    // var cmdWorker=new SharedWorker(
    //   new URL('@/services/bluetooth-api-worker', import.meta.url),
    //   { type: 'module' }
    // );
    this.bluetooth = new PWBHost(blWorker);
    this.shareBluetooth = new BluetoothHostShareWorker(this.bluetooth);//    new PWBHost(cmdWorker);
    this.connectedAtlestOnce = false;
    // this.options = options;
    this.botState = new BehaviorSubject(false);
    this.onConnect = new Subject();





    // this.worker.start();
    // this.promiseWorker = new PromiseWorker(this.worker);
    this.messages = new QueueDataLeanbot();
    this.data = new Subject<IMessageWorker>();
    this.activated = false;
    this.setupEventsHandler();


  }
  /**
   * Check whatever current tab is connected to bot
   * @returns boolean
   */
  async isBotConnect() {
    var bot = await this.shareBluetooth.getCurrentBot();

    return bot.host == this.shareBluetooth.host;
  }
  private async botMonitorSchedule() {
    // we only update botState if bot bas been connected atlest once time
    while (true) {
      if (this.connectedAtlestOnce) {
        var isConnect = await this.isBotConnect();
        if (isConnect != this.botState.getValue()) {
          this.botState.next(isConnect);
        }
      }
      await LeanbotSleep(300);
    }
    
  }
  private setupEventsHandler() {
   
    
    this.botMonitorSchedule();

    this.bluetooth.register(async e => {
      var data = e as any as IMessageWorker;
      // console.log("serial host event:",data)
      switch (data.type) {
        case EWorker.CMD_HOST_START_BOT:
          // debugger;
          await this.bluetooth.postMessage({type:EWorker.CMD_HOST_START_BOT});
          break;
        // this event happend when user remove usb cable, or bluetooth module
        case EWorker.EVENT_DISCONNECT:
          await this.shareBluetooth.removeCurrentBot();
          // this.onConnect.next(data);
          break;
        case EWorker.ON_CONNECTED:
          await this.shareBluetooth.setCurrentBot();
          this.onConnect.next(data);
          break;
        case EWorker.BOTDATA:
          this.messages.next(data.data);
          break;
        case EWorker.DEBUG:

          break;
        // case EWorker.CMD_DISCONNECT_REQUEST:
        //   // debugger;
        //   await this.send({type:EWorker.CMD_DISCONNECT});
        //   // this.onConnect.next(data);
        //   break;
        // case EWorker.CMD_DISCONNECT:

        //   await this.send(data);
        //   break;
      }
      // console.log(data)
      this.data.next(data);

    })
  }
  async send(message: IMessageWorker) {
    return await this.bluetooth.postMessage(message);
  }
  async startBot() {
    await this.write(new Uint8Array([0x41, 0x0a]).buffer)
  }
  async write(data: ArrayBuffer) {
    try {
      await this.bluetooth.postMessage({ type: EWorker.WRITE, data: data });
    }
    catch (err) {
      console.error("Write bluetooth error:", err);
      return "00||00";
      // styleDisplayNone();
    }
  }
  async disconnect() {
    // disconnect all bot
    await this.shareBluetooth.broadcastDisconnectBot();

    // waiting for bot disconnect
    while (true) {
      var bot = await this.shareBluetooth.getCurrentBot();
      if (bot.host == -1) break;
      // console.log("disconnecting ....")
      await LeanbotSleep(100);
    }
  }
  setOptions(options: SerialOptions) {
    this.options = options;
  }
  private async connect(force: boolean = false) {
    // because when user remove usb cable and reconnect it, then the port object has been disposed

    // if (p!==false) {
    // if (this.connectedAtlestOnce || force) {

    await this.send({ type: EWorker.SET_OPTIONS, data: JSON.stringify(this.options) })

    await this.disconnect();

    // this.shareWorker.port.postMessage({type:EWorker.EDISCONNECT})
    // retry during 10 sec to connect
    // debugger;
    // while (true) {
    // var rs = false;
    var count = 0;
    var err = "";
    // sometime we get the error cannot open serial port, but it is ok if we try to connect
    // several times.
    while (count < 5) {
      err = "";
      var d = await this.send({ type: EWorker.CONNECT, data: this.portIdx });
      // var rs = d.type == EWorker.CONNECT;
      if (d.type == EWorker.ERROR) {
        console.error(`connect error ${count}: ${this.portIdx}`,d.data);
        err = d.data;
        count=count+1;
        await LeanbotSleep(500);
      } else {
        break;
      }
    }
    if (err != "") {
      throw new Error(err);
    }
    //   await LeanbotSleep(500);
    //   console.log("Connecting...")
    // }
    // await this.shareBluetooth.setCurrentBot();
    this.connectedAtlestOnce = true;
    // }
    // }

  }
  private async getPort() {
    if (!('serial' in navigator)) {
      console.warn("Web Serial API is not supported in this browser.");
      return false;
    }
    const allPorts = await navigator.serial.getPorts();
    // if (port !== false) {
    var port = allPorts.map((o, i) => {
      return { port: o, index: i };
    }).filter((o, i) => {
      return o.port == this.lastPort
    });
    if (port.length) {
      this.portIdx = port[0].index;
      console.log("portIdx:",this.portIdx);
      return true;
    } else {
      console.log("portIdx: not found");
    }

    return false;
    // }
  }
  async selectPort() {
    if (!('serial' in navigator)) {
      alert("Device connection requires a Chrome or Edge browser to use the Web Serial API.");
      return false;
    }
    return await navigator.serial.requestPort()
      .then(async (port) => {
        this.lastPort = port;
        return await this.getPort();
        // return true;
      }).catch(e => false);


  }
  async reconnect(force: boolean = false) {
    var found = await this.getPort();
    if (!found) {
      throw new Error("Connection error, port not exist! are you remove usb cable or bluetooth module ?")
    }
    await this.send({ type: EWorker.SET_OPTIONS, data: JSON.stringify(this.options) })
    await this.connect(force);
  }

  async selectPortAndConnect() {
    await this.selectPort().then(async (done) => {
      if (done) {
        await this.connect(true);
      }
    });
  }
}
const bluetoothSerial=new BluetoothSerial();

export default bluetoothSerial;


